import { Component, Input } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  templateUrl: './deal-error-modal-template.html'
})
export class DealErrorModalComponent {
  @Input() context: { text: string };
  @Input() response: Subject<void>;

  cancel() {
    this.response.complete();
  }
}
